import { useQuery } from "@tanstack/react-query";

import * as types from "types";
import useGetAccessToken from "components/Login/useGetAccessToken";
import { getThreadMessages } from "../methods/getThreadMessages";

interface UseMessagesQueryOptions {
  threadId: types.ChatThread["id"];
  disabled?: boolean;
}

/**
 * Fetches the messages for a single chat thread.
 */
export default function useMessagesQuery({
  threadId,
  disabled,
}: UseMessagesQueryOptions) {
  const getAccessToken = useGetAccessToken();
  const isEnabled = disabled === undefined || disabled === false;

  return useQuery({
    queryKey: ["cc-db-api", "threads", threadId, "messages"],
    queryFn: () => getThreadMessages(threadId as string, getAccessToken),
    enabled: isEnabled,
    refetchOnWindowFocus: false,
    retry: false,
  });
}
